.error {
  grid-column-start: sidebar;
  grid-column-end: section;
  grid-row-start: 3;
  align-self: center;
}
.error > div {
  flex-direction: column;
  gap: var(--cxy-spacing-4);
}
.error > div h1 {
  color: var(--cxy-color-content-default);
}
